/* eslint-disable react-hooks/exhaustive-deps */
import { isEmpty } from "lodash";
import React, { useState, useEffect } from "react";
import { createEmployeeFamily, modifyEmployeeFamily } from "../../apis/employee/employee-family";
import useForm from "../../hooks/useForm";
import systemAlert from "../../utils/systemAlert";
import Form from "../Form";
import Modal, { ModalHeader } from "../Modal";

const defaultForm = {
  employeeIdx: "", // 직원 번호
  name: "", // 가족 이름
  relationship: "", // 가족관계
  birthDate: "", // 생일
  phone: "", // 연락처
}

const EmployeeFamilyDetailPopup = ({ open, setOpen, data, submit, employee }) => {
  const [mode, setMode] = useState('create')
  const [fields, setFields] = useState([])

  const _submit = (form) => {
    const _form = {
      ...form,
      birthDate: !isEmpty(form.birthDate) ? form.birthDate.toString() : ""
    }
    if (mode === 'create') {
      //추가
      systemAlert('가족정보를 추가하시겠습니까?', {
        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '확인',
            onClick: () => {
              createEmployeeFamily(_form)
                .then(() => {
                  submit();
                  cancel()
                })
                .catch(() => { })
                .finally(() => { })
            }
          }
        ]
      })
    } else {
      // 수정
      systemAlert('가족정보를 수정하시겠습니까?', {
        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '확인',
            onClick: () => {
              modifyEmployeeFamily(data.familyIdx, _form)
                .then(() => {
                  submit();
                  cancel();
                })
                .catch(() => { })
                .finally(() => { })
            }
          }
        ]
      })
    }
  }

  const {
    form,
    errors,
    handleSubmit,
    handleOnChange,
    setForm,
    setOriginForm,
  } = useForm(
    defaultForm,
    _submit
  );

  useEffect(() => {
    setMode(isEmpty(data) ? 'create' : 'modify')
    if (isEmpty(data)) {
      if (!isEmpty(employee)) {
        setForm({
          ...defaultForm,
          employeeIdx: employee.idx
        })

        setOriginForm({
          ...defaultForm,
          employeeIdx: employee.idx
        })
      }
    } else {
      setForm(data)
      setOriginForm(data)
    }
  }, [open, employee, data])

  useEffect(() => {
    setFields([
      {
        title: '가족명',
        key: 'name',
        type: 'input',
        required: true,
      },
      {
        title: '가족관계',
        key: 'relationship',
        type: 'input',
        required: true,
      },
      {
        title: '생년월일',
        key: 'birthDate',
        type: 'datepicker',
        required: true,
      },
      {
        title: '연락처',
        key: 'phone',
        type: 'input',
      }
    ])
  }, [form])

  const cancel = () => {
    setOpen(false)
    setForm(defaultForm)
    setOriginForm(defaultForm)
  }

  return (
    <Modal
      size="md"
      isOpen={open}
      close={cancel}
    >
      <div className="salary-bank-account-modal">
        <ModalHeader>가족정보 {mode === 'create' ? '등록' : '수정'}</ModalHeader>
        <Form
          form={form}
          errors={errors}
          isRequiredShow={true}
          setForm={setForm}
          fields={fields}
          onChange={handleOnChange}
          submitText={mode === 'create' ? '등록' : '수정'}
          submit={handleSubmit}
          cancel={cancel}
        />
      </div>
    </Modal>
  )
}

export default EmployeeFamilyDetailPopup
